export default __webpack_public_path__ + "93c38fd92f23f96556ef65de11254154.jpeg";